import * as formValidation from 'Modules/formValidation';

namespace BHW.caseAttachment {

	const POST_UPLOAD_FILE = '/api/salesforce/upload-file';

	let $alertSuccess = $('.js-alert-success');
	let $alertDanger = $('.js-alert-danger');

	let $uploadFile = $('#upload-file');
	let $uploadFileForm = $('#upload-file-form');	
	let $uploadFileFile = $('#upload-file-file');
	let $uploadFileSubmit = $('#upload-file-submit');
	let $uploadFilePleaseWait = $('#upload-file-please-wait');
	let $uploadFileCancel = $('#upload-file-cancel');
	let uploadFiles =[];
	
	let constraintsUploadFile = {		
		'upload-file-file': {
			presence: {
				allowEmpty: false,
				message: '^' + 'File Required'
			}
		}
	};

	let validateField = function (e, form) {
		$(e.target).addClass('dirty');
		let constraints = {};
		let values = {};
		let $submit = $;
		switch (form) {			
			case 'uploadFile':
				constraints = constraintsUploadFile;
				values = {					
					'upload-file-file': $('.js-file-input-value').text()
				};
				$submit = <any>$uploadFileSubmit;
		}		
	};
	

	let inputEventListeners = function () {
		document.getElementById('upload-file-file').onchange = function(e) {
			setTimeout(function(){				
				if (($uploadFileFile[0] as any).files.length) {
					if($uploadFileFile.val() == '') {
						$uploadFileSubmit.attr("disabled", 'true');
						<any>$uploadFileSubmit.trigger('change');
					} else {
						validateField(e, 'uploadFile');
					}
				} else {
					$uploadFileSubmit.attr("disabled", 'true');
					validateField(e, 'uploadFile');
				}
			},300);

		};
		
	};

	let setupHandlers = function(){
		//waiting a second here so that the fileinput.ts binding that happens can be turned off.
		setTimeout(function(){
			$('input[type=file]').off('change.file');
			$('#upload-file-file').on('change.upload', function(e){
				var $value = $(this).siblings('.js-file-input-value');
				var $this = $(this);
				var $eTarget = <any>e.target;
				if (((this) as any).files && ((this) as any).files[0]) {
					if($eTarget.files.length <= 5)
					{
						uploadFiles = [];
						var output = [];
						for(var i=0; i<$eTarget.files.length; i++)
						{
							uploadFiles.push($eTarget.files[i]);
							let removeLink = '<i data-fileid=\"' + i + '\" class="icon icon-times file-input-close js-remove-file text-blue-bright" title="Remove Image"></i>';
							output.push('<li><strong>'+ $eTarget.files[i].name + '</strong>'+ removeLink+ '</li> ');
						}
						$value.html('');
						$value.append(output.join(""));
						if($this.data("accept")) {
							let fileAssocArray = $this.data("accept").split(',');
							for(var i=0; i<$eTarget.files.length; i++)
							{
								let fileName = $eTarget.files[i].name;
								let fileExt = (fileName.split(/[. ]+/).pop()).toLowerCase();
								if(fileAssocArray.indexOf(`.${fileExt}`) > -1)
								{

								}
								else
								{
									$value.html('');
									alert(`.${fileExt} files are not allowed. Please choose one of the following file types: (${fileAssocArray})`);
								}
							}
						}
					}
					else
					{
						alert(`Cannot upload more than 5 files`);
					}
				} else {
					$value.html('');
				}
			});
		}, 1000);

		// remove clicked file
		$('body').on('click.register', '.js-remove-file', function(e){
			e.preventDefault();
			var fileName = $(this).parent().children("strong").text();
			for(let i = 0; i < uploadFiles.length; ++ i){
				if(uploadFiles[i].name == fileName){
					uploadFiles.splice(i, 1);
				}
			}
			$(this).parent().remove();
		});
	};
	

	let submitUploadFile = function () {
		$uploadFileSubmit.on('click', function (e) {
			e.preventDefault();

			$('.alert').addClass('hidden');

			$uploadFileSubmit.addClass('hidden');
			$uploadFilePleaseWait.removeClass('hidden');
			$uploadFileCancel.attr('disabled', '');

			let data = new FormData();
			data.append("Id", location.search.slice(1).split('=')[1]);			
            for(var i=0; i<($uploadFileFile[0] as any).files.length; i++)
		    data.append("Files" +i, ($uploadFileFile[0] as any).files[i]);
			$.ajax({
				url: POST_UPLOAD_FILE,
				type: 'POST',
				dataType: 'json',
				data: data,
				processData: false,
				contentType: false // not json
			})
				.done(function () {
					$('[data-target="#upload-file"]').click();
					$alertSuccess.removeClass('hidden');
					window.location.reload();
				})
				.fail(function (response) {
					$alertDanger
						.removeClass('hidden')
						.find('.alert__text');
						//.text(response.responseJSON.ExceptionMessage);
					$uploadFileSubmit.removeClass('hidden');
					$uploadFilePleaseWait.addClass('hidden');
				})
				.always(function () {
					window.scrollTo(0, 0);
					$uploadFileCancel.removeAttr('disabled');
				});
		});
		$uploadFileCancel.on('click', function (e) {
			e.preventDefault();

			formValidation.resetForm($uploadFileForm);
			$('.js-file-input-value').text('');
			$('[data-target="#upload-file"]').click();
		});
	};

	export const init = () => {
		// Something is unwrapping the form so this puts it back		
		if($uploadFileForm.length === 0){
			$uploadFileForm = $(`<form id="upload-file-form" name="upload-file-form">`);
			$uploadFile.append($uploadFileForm.append($uploadFile.children().detach()));
		}
		inputEventListeners();
		setupHandlers();		
		submitUploadFile();
	};
}

document.addEventListener("DOMContentLoaded", () => {
	BHW.caseAttachment.init();
});

